import '@patsnap-ui/icon/assets/solid/CloseMedium.svg'
import { computed, defineComponent, ref } from '@vue/composition-api'
import { GDialog, GIcon } from 'pharmsnapMF_shared/components'
import { useAuthStore, useLocale } from 'pharmsnapMF_shared/composition'
import { ElCheckbox } from 'pharmsnapMF_shared/element-ui'
import switchTenantGuideGifCn from './assets/switch_tenant_guide_cn.gif'
import switchTenantGuideGifEn from './assets/switch_tenant_guide_en.gif'
import cn from './locales/cn.json'
import en from './locales/en.json'
import styles from './SwitchTenantGuideDialog.module.scss'

export const SwitchTenantGuideDialog = defineComponent({
  name: 'SwitchTenantGuideDialog',
  i18n: {
    messages: {
      cn,
      en,
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const { isCN } = useLocale()
    const {
      state: { upgrade },
    } = useAuthStore()
    const doNotShowAgain = ref(false)
    const headerTipVisible = ref(false)
    const switchTenantGuideGif = computed(() => {
      return isCN.value ? switchTenantGuideGifCn : switchTenantGuideGifEn
    })

    const showHeaderTip = () => {
      headerTipVisible.value = true
    }

    const handleCancel = () => {
      emit('cancel', doNotShowAgain.value)
    }

    const handleSwitchTenant = () => {
      emit('switchTenant', doNotShowAgain.value)
      showHeaderTip()
      // 用户优先去切租户，如果有升级弹窗，先关闭升级弹窗
      if (upgrade.value.show) {
        upgrade.value.show = false
      }
    }

    return {
      doNotShowAgain,
      headerTipVisible,
      switchTenantGuideGif,
      handleCancel,
      handleSwitchTenant,
    }
  },
  methods: {
    renderHeaderTip() {
      if (!this.headerTipVisible) {
        return null
      }

      return (
        <div class={styles.switchTenantHeaderTipMask}>
          <div class={styles.switchTenantHeaderTip}>
            <div class={styles.switchTenantHeaderTipHeader}>
              <div class={styles.switchTenantHeaderTipTitle}>{this.$tc('SwitchTenantGuideDialog.headerTipTitle')}</div>
              <GIcon
                svgName="SolidCloseMedium"
                size={24}
                class="text-gray-450 cursor-pointer"
                nativeOnClick={() => (this.headerTipVisible = false)}
              ></GIcon>
            </div>
            <div class={styles.switchTenantHeaderTipDesc}>{this.$tc('SwitchTenantGuideDialog.headerTipDesc')}</div>
            <div class="text-right">
              <button class="pt-ui-btn" type="button" data-type="submit" data-size="small" onClick={() => (this.headerTipVisible = false)}>
                {this.$tc('SwitchTenantGuideDialog.headerTipConfirm')}
              </button>
            </div>
          </div>
        </div>
      )
    },
  },
  render() {
    return (
      <div>
        <GDialog
          visible={this.visible}
          appendToBody
          destroyOnClose
          showClose={false}
          width="500px"
          title={this.$tc('SwitchTenantGuideDialog.title')}
          cancelText={this.$tc('SwitchTenantGuideDialog.continueUseIndividual')}
          confirmText={this.$tc('SwitchTenantGuideDialog.switchTenant')}
          onCancel={this.handleCancel}
          onConfirm={this.handleSwitchTenant}
          customClass={styles.switchTenantGuideDialog}
        >
          <div class={styles.switchTenantGuide}>
            <div class={styles.switchTenantGuideIntro}>{this.$tc('SwitchTenantGuideDialog.intro')}</div>
            <div class={styles.switchTenantGuideTip}>{this.$tc('SwitchTenantGuideDialog.tip')}</div>
            <div class={styles.switchTenantGuidePreview}>
              <img
                class={styles.switchTenantGuideGif}
                src={this.switchTenantGuideGif}
                alt={this.$tc('SwitchTenantGuideDialog.imageAlt')}
                draggable={false}
              />
            </div>

            <ElCheckbox
              class={styles.switchTenantGuideCheckbox}
              value={this.doNotShowAgain}
              onChange={(value: boolean) => (this.doNotShowAgain = value)}
            >
              {this.$tc('SwitchTenantGuideDialog.doNotShowAgain')}
            </ElCheckbox>
          </div>
        </GDialog>
        {this.renderHeaderTip()}
      </div>
    )
  },
})
